// extracted by mini-css-extract-plugin
export default {"loader":"UiLoading_loader__lhsA1","shadow":"UiLoading_shadow__ROkUS"};